module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/ltv_features_03-b95b3838111ccfc13fc0682321f0969e.png";